import FooterForm from "./footer-form/footer-form";
import FooterInfo from "./footer-info/footer-info";
import iFooterBg from "../../../assets/icons/footer/footer-bg.svg";
import "./footer.sass";

type Props = {
  isFooterFormVisible?: boolean;
  isFooterVisible?: boolean;
};

const Footer = ({
  isFooterFormVisible = true,
  isFooterVisible = true,
}: Props) => {
  return isFooterVisible ? (
    <div className="footer">
      {isFooterFormVisible && <FooterForm />}

      <FooterInfo />

      <img src={iFooterBg} className="footer__bg" alt="" />
    </div>
  ) : null;
};

export default Footer;
